// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/my_account/settings.proto (package protos.entities.app.my_account, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file entities/app/my_account/settings.proto.
 */
export const file_entities_app_my_account_settings: GenFile = /*@__PURE__*/
  fileDesc("CiZlbnRpdGllcy9hcHAvbXlfYWNjb3VudC9zZXR0aW5ncy5wcm90bxIecHJvdG9zLmVudGl0aWVzLmFwcC5teV9hY2NvdW50Iq8CCghTZXR0aW5ncxJNCg1ub3RpZmljYXRpb25zGAEgASgLMjYucHJvdG9zLmVudGl0aWVzLmFwcC5teV9hY2NvdW50LlNldHRpbmdzLk5vdGlmaWNhdGlvbnMa0wEKDU5vdGlmaWNhdGlvbnMSSQoEcHVzaBgBIAEoCzI7LnByb3Rvcy5lbnRpdGllcy5hcHAubXlfYWNjb3VudC5TZXR0aW5ncy5Ob3RpZmljYXRpb25zLlB1c2gadwoEUHVzaBIbChNuZXdfam9iX2FwcGxpY2F0aW9uGAEgASgIEhwKFGNvbm5lY3Rpb25fcmVxdWVzdGVkGAIgASgIEhsKE2Nvbm5lY3Rpb25fYWNjZXB0ZWQYAyABKAgSFwoPbWVzc2FnZV9jcmVhdGVkGAQgASgIYgZwcm90bzM");

/**
 * @generated from message protos.entities.app.my_account.Settings
 */
export type Settings = Message<"protos.entities.app.my_account.Settings"> & {
  /**
   * @generated from field: protos.entities.app.my_account.Settings.Notifications notifications = 1;
   */
  notifications?: Settings_Notifications | undefined;
};

/**
 * Describes the message protos.entities.app.my_account.Settings.
 * Use `create(SettingsSchema)` to create a new message.
 */
export const SettingsSchema: GenMessage<Settings> = /*@__PURE__*/
  messageDesc(file_entities_app_my_account_settings, 0);

/**
 * @generated from message protos.entities.app.my_account.Settings.Notifications
 */
export type Settings_Notifications = Message<"protos.entities.app.my_account.Settings.Notifications"> & {
  /**
   * @generated from field: protos.entities.app.my_account.Settings.Notifications.Push push = 1;
   */
  push?: Settings_Notifications_Push | undefined;
};

/**
 * Describes the message protos.entities.app.my_account.Settings.Notifications.
 * Use `create(Settings_NotificationsSchema)` to create a new message.
 */
export const Settings_NotificationsSchema: GenMessage<Settings_Notifications> = /*@__PURE__*/
  messageDesc(file_entities_app_my_account_settings, 0, 0);

/**
 * @generated from message protos.entities.app.my_account.Settings.Notifications.Push
 */
export type Settings_Notifications_Push = Message<"protos.entities.app.my_account.Settings.Notifications.Push"> & {
  /**
   * @generated from field: bool new_job_application = 1;
   */
  newJobApplication: boolean;

  /**
   * @generated from field: bool connection_requested = 2;
   */
  connectionRequested: boolean;

  /**
   * @generated from field: bool connection_accepted = 3;
   */
  connectionAccepted: boolean;

  /**
   * @generated from field: bool message_created = 4;
   */
  messageCreated: boolean;
};

/**
 * Describes the message protos.entities.app.my_account.Settings.Notifications.Push.
 * Use `create(Settings_Notifications_PushSchema)` to create a new message.
 */
export const Settings_Notifications_PushSchema: GenMessage<Settings_Notifications_Push> = /*@__PURE__*/
  messageDesc(file_entities_app_my_account_settings, 0, 0, 0);

